import React, { Component } from "react";
import { connect } from "react-redux";
import isArray from "../../../../function/isArray";

export class SubOptionsLv3ExtraDescription extends Component {
  render() {
    const { lv3Default, subOptionLv3DisplayList } = this.props;
    const subitems = subOptionLv3DisplayList.subitems;
    let extraDescription = "";
    if (isArray(subitems)) {
      const activeSubitem = subitems.find(item => item.code === lv3Default);
      if (activeSubitem) extraDescription = activeSubitem.extraDescription;
    }
    return <div>{extraDescription}</div>;
  }
}

const mapStateToProps = state => {
  return {
    lv3Default: state.product.lv3Default,
    subOptionLv3DisplayList: state.product.subOptionLv3DisplayList
  };
};

const mapDispatchToProps = () => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubOptionsLv3ExtraDescription);
